// Where a planning drag started: a bar off a timeline row, or an item out of a tray.
export enum TimelineDragSource {
  bar = 'bar',
  tray = 'tray',
}
